var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TipBox',{attrs:{"info":"","title":_vm.$t('tips.open_hours.title')}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('tips.open_hours.description'))}}),_c('ul',[_c('li',{domProps:{"innerHTML":_vm._s(_vm.$t('tips.open_hours.description_li_1'))}}),_c('li',{domProps:{"innerHTML":_vm._s(_vm.$t('tips.open_hours.description_li_2'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }